import PageList from '#/modules/commonComponents/PageList';
import productRepairNavigate from '#/modules/infra/navigation/productRepairNavigate';

const ProductRepairHubPage = () => (
  <PageList title="產品維修" linkList={productRepairNavigate} />
);

export default ProductRepairHubPage;
